import React, { useState, Suspense, useEffect } from 'react';
import './App.css';
// import default style
import 'rsuite/styles/index.less'; // or 'rsuite/dist/rsuite.min.css'

import HowToModal from './Modal';
import GettingStarted from './GettingStarted';
import { Routes, Route, Link } from 'react-router-dom';
import Articles from './Articles';
import Payments from './Payments';
import Kubonds from './Kubonds';
import Home from './Home';
import Support from './Support';
import LocaleContext from './LocaleContext';
import Loading from './Loading';
import i18n from './i18n';
import { withAuthenticator } from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
import Analytics from '@aws-amplify/analytics';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
/**
 * Support personalized configurations such as localization, Right to Left, and themes
 */

import {
  Button,
  CustomProvider,
  ButtonToolbar,
  Panel,
  Nav,
  Navbar,
  Dropdown,
} from 'rsuite';
Amplify.configure(awsconfig);
const styles = {
  marginBottom: 50,
};
const CustomNav = ({ active, onSelect, ...props }) => {
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect} style={styles}>
      <Nav.Item eventKey="home">Home</Nav.Item>
      <Nav.Item eventKey="news">Kubonds</Nav.Item>
      <Nav.Item eventKey="solutions">Payments</Nav.Item>
      <Nav.Item eventKey="products">Support</Nav.Item>
      <Nav.Item eventKey="about">About</Nav.Item>
    </Nav>
  );
};

const mapObj = (f) => (obj) =>
  Object.keys(obj).reduce((acc, key) => ({ ...acc, [key]: f(obj[key]) }), {});
const toArrayOfStrings = (value) => [`${value}`];
const mapToArrayOfStrings = mapObj(toArrayOfStrings);

function App() {
  async function trackUserId() {
    try {
      const { attributes } = await Auth.currentAuthenticatedUser();
      const userAttributes = mapToArrayOfStrings(attributes);
      console.log('-----> ' + JSON.stringify(userAttributes));
      Analytics.updateEndpoint({
        address: userAttributes.email[0],
        channelType: 'EMAIL',
        optOut: 'NONE',
        userId: userAttributes.sub[0],
        userAttributes,
      });
    } catch (error) {
      console.log(error);
    }
  }

  // const [theme, setTheme] = useState('light');
  const [active, setActive] = React.useState('home');
  const [locale, setLocale] = useState(i18n.language);
  i18n.on('languageChanged', (lng) => setLocale(i18n.language));
  // const switchTheme = (e) => setTheme(e.target.value);
  useEffect(() => {
    // Update the document title using the browser API
    trackUserId();
  });
  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {/* <AmplifySignOut /> */}
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="kubonds" element={<Kubonds />} />
          <Route path="payments" element={<Payments />} />
          <Route path="support" element={<Support />} />
        </Routes>
        {/* <GettingStarted /> */}
        {/* <div>
        <CustomNav appearance="tabs" active={active} onSelect={setActive} />
      </div> */}
        {/* <div className="App">
         <ButtonToolbar>
          <Button appearance="default" onClick={switchTheme} value="light">
            Light theme(default)
          </Button>
          <Button appearance="primary" onClick={switchTheme} value="dark">
            Dark theme
          </Button>
          <Button
            appearance="ghost"
            onClick={switchTheme}
            value="high-contrast"
          >
            High contrast theme
          </Button>
        </ButtonToolbar> 
        <Panel
          shaded
          bordered
          bodyFill
          style={{ display: 'inline-block', width: 240 }}
        >
          <img src="https://via.placeholder.com/240x240" height="240" />
          <Panel header="RSUITE">
            <p>
              <small>
                A suite of React components, sensible UI design, and a friendly
                development experience.
              </small>
            </p>
          </Panel>
        </Panel>
        <Panel
          shaded
          bordered
          bodyFill
          style={{ display: 'inline-block', width: 240 }}
        >
          <img src="https://via.placeholder.com/240x240" height="240" />
          <Panel header="RSUITE">
            <p>
              <small>
                A suite of React components, sensible UI design, and a friendly
                development experience.
              </small>
            </p>
          </Panel>
        </Panel>
        <Panel
          shaded
          bordered
          bodyFill
          style={{ display: 'inline-block', width: 240, margin: 20 }}
        >
          <img src="https://via.placeholder.com/240x240" height="240" />
          <Panel header="RSUITE">
            <p>
              <small>
                A suite of React components, sensible UI design, and a friendly
                development experience.
              </small>
            </p>
          </Panel>
        </Panel>
        <Panel
          shaded
          bordered
          bodyFill
          style={{ display: 'inline-block', width: 240 }}
        >
          <img src="https://via.placeholder.com/240x240" height="240" />
          <Panel header="RSUITE">
            <p>
              <small>
                A suite of React components, sensible UI design, and a friendly
                development experience.
              </small>
            </p>
          </Panel>
        </Panel>x
      </div> */}
        {/* <HowToModal />
      <Articles /> */}
        {/* <Payments />
      <Kubonds /> */}
      </Suspense>
    </LocaleContext.Provider>
  );
}

export default withAuthenticator(App);
